export const SET_LOUNGE_DETAILS =
  'modules/travel-lounge-finder-root/SET_LOUNGE_DETAILS';

export const setLoungeDetails = (details = {}) => ({
  type: SET_LOUNGE_DETAILS,
  payload: details,
});

export const loungeReducer = (state = {}, action = {}) => {
  switch (action?.type) {
    case SET_LOUNGE_DETAILS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
